import React, { useState, useEffect, useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useManualQuery, useMutation, ClientContext } from "graphql-hooks";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Container,
  Checkbox,
  TextField,
  Typography,
  Grid,
  makeStyles,
  Button,
  Divider,
  Tooltip,
} from "@material-ui/core";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

import draftToHtml from "draftjs-to-html";
import ReactHtmlParser from "react-html-parser";

import ShortTextIcon from "@mui/icons-material/ShortText";
import SubjectIcon from "@mui/icons-material/Subject";
import TocIcon from "@mui/icons-material/Toc";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import dropdownImg from "../../assets/icons/dropdown.png";

import styled from "styled-components";

import AlertDialog from "../../components/AlertDialog.js";

import Header from "../forms/Header.js";
import {
  REFRESH_TOKEN_MUTATION,
  STAFF_MODULE_ACCESS_QUERY,
} from "../../graphQL/user_qry";
import { GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY } from "../../graphQL/component_qry";
import { project_url } from "../../constants/Data";


const UPDATA_ANSWER_SCORE = `mutation updateAnswerScore($answerId: Int!, $score: Int!) {
  updateAnswerScore(
    answerId: $answerId,
    score: $score,
  ) {
    answerObj {
      answerId
      score
		}
	}
}`;

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
    marginTop: 20,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "120px",
    padding: 0,
    color: "#fff",
    height: "34px",
    marginTop: 20,
    backgroundColor: "#0D47A1",
    textTransform: "none",
    //  textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "&.MuiDataGrid-scrollbar MuiDataGrid-scrollbar--horizontal css-1rtad1": {
      position: "relative",
      display: "block",
    },
    "&.MuiDataGrid-root": {
      //  minWidth: 980,
      //  width:"100%"
      //  overflowX: 'scroll'
    },

    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 14,
      paddingLeft: 50,
    },
  },

  textField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      height: 50,
      width: 300,
      textAlign: "center",
      fontSize: 14,
      //  backgroundColor: "White",
      color: "#212121",
      paddingLeft: 2,
      marginTop: 5,
      marginBottom: 5,
      paddingBottom: 5,
    },
  },
  scoreTextField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      height: 30,
      width: 100,
      textAlign: "center",
      fontSize: 14,
      //  backgroundColor: "White",
      color: "#212121",
      // paddingLeft: 2,
      marginTop: 7,
      marginBottom: 7,
      marginRight: 110,
    },
  },
  answerSelectStyle: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      height: 40,
      fontSize: 14,
      color: "#212121",
      marginTop: 4,
    },
  },

  drpdwnTextField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      height: 35,
      width: 300,
      textAlign: "center",
      fontSize: 14,
      //  backgroundColor: "White",
      color: "#212121",
      // paddingLeft: 2,
      // marginTop: 5,
      // marginBottom: 5,
      // paddingBottom: 5,
      padding: 0,
      paddingTop: 7,
      paddingBottom: 7,
      marginTop: 7,
    },
  },
}));

function ScorePage() {
  const classes = useStyles();
  const { formUuid } = useParams();
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const client = useContext(ClientContext);

  const [loadData, setLoadData] = useState(false);
  const [loadContent, setLoadContent] = useState(false);
  const [formName, setFormName] = useState("");
  const [formLink, setFormLink] = useState(null);
  const [formObjPage, setFormObjPage] = useState("");
  const [rows, setRows] = useState([]);
  const [rowsScore, setRowsScore] = useState([]);
  const [updtState, setUpdtState] = useState(true);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  let tenantUserId = 0;
  if (localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;
  if (localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");

  let clientName = "";
  if (localStorage.getItem("clientName")) clientName = localStorage.getItem("clientName");

  const [fetchFormComponentsAnswers] = useManualQuery(
    GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY
  );
  const [updateAnswerScore] = useMutation(UPDATA_ANSWER_SCORE);

  // const convertTxtToRichTxt = txt => {
  //   let contentHTML = draftToHtml(JSON.parse(txt.replace(/'/g, '"')));
  //   contentHTML = contentHTML.replace(/<p>/, "");
  //   const convertedTxt = ReactHtmlParser(contentHTML);
  //   return convertedTxt;
  // };

  const convertTxtToRichTxt = txt => {
    //let contentHTML = draftToHtml(JSON.parse(txt.replace(/'/g, '"')));
    //comment by sami
    let contentHTML = draftToHtml(JSON.parse(txt));
    contentHTML = contentHTML.replace(/<p>/, "");

    contentHTML = contentHTML.replace(
      /<a[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/gi,
      (match, href, text) => {
        // Remove leading protocols
        href = href.replace(/^(https?:\/\/)+/, "");

        // Prepend https://
        href = `https://${href}`;

        return `<a href="${href}" target="_blank">${text}</a>`;
      }
    );
    const convertedTxt = ReactHtmlParser(contentHTML);
    return convertedTxt;
  };

  const [assignScoresAccess, setAssignScoresAccess] = useState(true);

  const checkAccess = async () => {
    const {
      loading: accessDataLoading,
      error: accessDataError,
      data: accessData,
    } = await checkStaffModuleAccess({
      variables: {
        tenantUserId: parseInt(tenantUserId),
        clientId: parseInt(clientId),
        moduleName: "Forms",
        modulepageName: "List",
      },
    });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {
      let additionalActions = accessData.staffModuleAccess.additionalActions.split("|");

      if (additionalActions.find(a => a == "Assign Scores")) setAssignScoresAccess(true);
      else setAssignScoresAccess(false);
    }

    if (
      accessDataError &&
      accessDataError.graphQLErrors &&
      accessDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const getFormComponentsAnswers = async () => {
    if (!formUuid) return;
    const {
      loading: formComponentsLoading,
      error: formComponentsError,
      data: formComponents,
    } = await fetchFormComponentsAnswers({
      variables: { formUuid: formUuid },
    });
    if (
      !formComponentsLoading &&
      formComponents &&
      formComponents.formComponentAnswerList
    ) {
      // console.log("allComponents----", formComponents);
      // console.log(formComponents.formComponentAnswerList);
      setFormName(formComponents.formComponentAnswerList.name);
      setFormObjPage(`${project_url}/forms/`); // + formUuid);
      setLoadData(true);
      if (!formComponents.formComponentAnswerList.approved)
        setFormLink(`${project_url}/forms/${formUuid}`);
      let tmp = [];
      for (var i in formComponents.formComponentAnswerList.componentList) {
        let frmCmp = formComponents.formComponentAnswerList.componentList[i];
        // console.log(frmCmp);
        let data = {};
        data["id"] = frmCmp.componentId;
        data["question"] = convertTxtToRichTxt(frmCmp.label);
        data["type"] = frmCmp.answerTypeId.name;
        data["mandatory"] = frmCmp.mandatory;
        // console.log(frmCmp.answerList);

        if (
          frmCmp.answerTypeId.name === "text" ||
          frmCmp.answerTypeId.name === "textarea"
        ) {
          data["answer"] = frmCmp.answerList[0].value;
          data["score"] = frmCmp.answerList[0].score;
          data["answerId"] = frmCmp.answerList[0].answerId;
          data["scoreErrorFiled"] = false;
        } else if (
          frmCmp.answerTypeId.name === "radio_button" ||
          frmCmp.answerTypeId.name === "checkbox_multiple" ||
          frmCmp.answerTypeId.name === "drop_down"
        ) {
          data["answer"] = frmCmp.answerList.map(ansLst => ansLst["label"]);
          data["score"] = frmCmp.answerList.map(ansLst => ansLst["score"]);
          data["answerId"] = frmCmp.answerList.map(ansLst => ansLst["answerId"]);
          data["scoreErrorFiled"] = Array(frmCmp.answerList.length).fill(false);
        } else if (frmCmp.answerTypeId.name === "checkbox_single") {
          data["score"] = frmCmp.answerList[0].score;
          data["answerId"] = frmCmp.answerList[0].answerId;
          data["scoreErrorFiled"] = false;
        }
        tmp.push(data);
      }

      setRows(tmp);

      // console.log(tmp);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    (() => getFormComponentsAnswers())();
  }, [formUuid]);

  const updateScores = (value, answerId, rowData, indx = -1) => {
    if (value < 0) {
      // console.log(rowData);
      // console.log(indx);
      if (indx !== -1) rowData["scoreErrorFiled"][indx] = true;
      else rowData["scoreErrorFiled"] = true;
      setUpdtState(!updtState);
      return;
    }
    if (indx !== -1) rowData["scoreErrorFiled"][indx] = false;
    else rowData["scoreErrorFiled"] = false;

    const findAnswerScore = findAnd.returnFound(
      rowsScore,
      { answerId: answerId },
      { score: value }
    );
    if (findAnswerScore === undefined)
      setRowsScore([...rowsScore, { answerId: answerId, score: value }]);
    else {
      const currScore = findAnd.changeProps(
        rowsScore,
        { answerId: answerId },
        { score: value }
      );
      setRowsScore(currScore);
    }
  };

  const saveScores = async () => {
    for (var i in rowsScore) {
      if (isNaN(parseInt(rowsScore[i].score)) || parseInt(rowsScore[i].score) < 0) return;
    }
    for (var i in rowsScore) {
      let {
        loading: loadUpdateAnswerScore,
        error: errorUpdateAnswerScorer,
        data: dataUpdateAnswerScore,
      } = await updateAnswerScore({
        variables: {
          answerId: parseInt(rowsScore[i].answerId),
          score: parseInt(rowsScore[i].score),
        },
      });
    }
    navigate(formObjPage);
  };

  const columns = [
    {
      field: "question",
      headerName: "Question",
      // minWidth: 180,
      flex: 2,
      sortable: false,
      align: "left",
      headerAlign: "left",
      disableColumnMenu: true,
      renderCell: params => {
        return (
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              paddingTop: 10,
            }}
          >
            {params.row.type === "text" && (
              <ShortTextIcon
                style={{
                  marginRight: 10,
                  color: "#fff",
                  backgroundColor: "#0057B2",
                  borderRadius: 4,
                }}
              />
            )}
            {params.row.type === "textarea" && (
              <SubjectIcon
                style={{
                  marginRight: 10,
                  color: "#fff",
                  backgroundColor: "#0057B2",
                  borderRadius: 4,
                }}
              />
            )}
            {params.row.type === "content" && (
              <TocIcon
                style={{
                  marginRight: 10,
                  color: "#fff",
                  backgroundColor: "#0057B2",
                  borderRadius: 4,
                }}
              />
            )}
            {params.row.type === "drop_down" && (
              <img
                style={{
                  marginRight: 10,
                  borderRadius: 4,
                  height: 24,
                }}
                src={dropdownImg}
              />
            )}
            {params.row.type === "radio_button" && (
              <RadioButtonCheckedIcon
                style={{
                  marginRight: 10,
                  color: "#fff",
                  backgroundColor: "#0057B2",
                  borderRadius: 4,
                }}
              />
            )}
            {params.row.type === "checkbox_multiple" && (
              <CheckBoxIcon
                style={{
                  marginRight: 10,
                  color: "#fff",
                  backgroundColor: "#0057B2",
                  borderRadius: 4,
                }}
              />
            )}
            {params.row.type === "checkbox_single" && (
              <CheckBoxIcon
                style={{
                  marginRight: 10,
                  color: "#fff",
                  backgroundColor: "#0057B2",
                  borderRadius: 4,
                  // marginTop: params.row.type === "checkbox_single" && 8,
                }}
              />
            )}
            {params.row.mandatory && (
              <StyledTooltip title="required field">
                <Typography
                  variant="h3"
                  style={{
                    display: "flex",
                    // alignItems: "center",
                    color: "#E53935",
                    paddingLeft: 5,
                    paddingRight: 5,
                  }}
                >
                  *
                </Typography>
              </StyledTooltip>
            )}
            <div>{params.row.question}</div>
          </Box>
        );
      },
    },
    {
      field: "answer",
      headerName: "Answer",
      // minWidth: 150,
      flex: 2,
      sortable: false,
      align: "left",
      headerAlign: "left",
      disableColumnMenu: true,
      renderCell: params => {
        if (params.row.type === "text") {
          return (
            // <Box mt={2}>
            <TextField
              className={classes.textField}
              variant="outlined"
              value={params.row.answer}
              inputProps={{ readOnly: true, tabIndex: "-1" }}
            />
            // </Box>
          );
        } else if (params.row.type === "textarea") {
          return (
            <TextField
              className={classes.textField}
              variant="outlined"
              value={params.row.answer}
              inputProps={{ readOnly: true, tabIndex: "-1" }}
              // multiline
              // rows={6}
            />
          );
        } else if (params.row.type === "radio_button") {
          return (
            <>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                >
                  {params.row.answer.map((item, i) => (
                    <FormControlLabel
                      value={item}
                      control={<Radio tabIndex={"-1"} />}
                      label={item}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
            </>
          );
        } else if (params.row.type === "drop_down") {
          if (params.row.answerId.length < 6) {
            return (
              <>
                {params.row.answer.map((item, i) => (
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      // alignItems: "center",
                      // justifyContent: "center",
                    }}
                  >
                    <TextField
                      className={classes.drpdwnTextField}
                      variant="outlined"
                      value={item}
                      inputProps={{ readOnly: true, tabIndex: "-1" }}
                    />
                  </Box>
                ))}
              </>
            );
          } else {
            return (
              <Box display="flex" alignItems="center" justifyContent="left">
                <TextField
                  className={classes.answerSelectStyle}
                  select
                  SelectProps={{ native: true }}
                  variant="outlined"
                  inputProps={{ readOnly: true, tabIndex: "-1" }}
                  // value={params.row.answer}
                >
                  {params.row.answer.map((item, i) => (
                    <option key={i} value={item}>
                      {item}
                    </option>
                  ))}
                </TextField>
              </Box>
            );
          }
        } else if (params.row.type === "checkbox_multiple") {
          return (
            <>
              {params.row.answer.map((item, i) => (
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "left",
                    alignItems: "center",
                  }}
                >
                  <Checkbox
                    // size="small"
                    style={{
                      // color: "#212121",
                      padding: 0,
                      paddingTop: 15,
                      paddingBottom: 3,
                    }}
                    tabIndex={"-1"}
                  />
                  <Typography variant="h3" style={{ paddingLeft: 8, paddingTop: 13 }}>
                    {item}
                  </Typography>
                </Box>
              ))}
            </>
          );
        } else if (params.row.type === "checkbox_single") {
          return (
            <Checkbox
              // size="small"
              style={{
                // color: "#212121",
                padding: 0,
                paddingTop: 13,
              }}
              tabIndex={"-1"}
            />
          );
        } else if (params.row.type == "content") {
          return (
            <Typography variant="h3" style={{ fontSize: 14, paddingTop: 15 }}>
              N/A
            </Typography>
          );
        }
      },
    },
    {
      field: "score",
      headerName: "Score",
      // minWidth: 90,
      flex: 1,
      sortable: false,
      align: "center",
      headerAlign: "left",
      disableColumnMenu: true,
      renderCell: params => {
        if (
          params.row.type === "text" ||
          params.row.type === "textarea" ||
          params.row.type === "checkbox_single"
        )
          return (
            <TextField
              className={classes.scoreTextField}
              name="score"
              variant="outlined"
              defaultValue={params.row.score != null ? params.row.score : 0}
              type="number"
              InputProps={{
                inputProps: { min: 0, pattern: "[0-9]*" },
              }}
              onChange={e =>
                updateScores(e.target.value, params.row.answerId, params.row)
              }
              helperText={params.row.scoreErrorFiled && "Cannot enter a negative number"}
              error={params.row.scoreErrorFiled}
            />
          );
        else if (
          params.row.type === "radio_button" ||
          params.row.type === "checkbox_multiple"
        ) {
          return (
            <>
              {params.row.score.map((item, i) => (
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <TextField
                    className={classes.scoreTextField}
                    name="score"
                    variant="outlined"
                    defaultValue={item}
                    type="number"
                    InputProps={{
                      inputProps: { min: 0, pattern: "[0-9]*" },
                    }}
                    onChange={e =>
                      updateScores(e.target.value, params.row.answerId[i], params.row, i)
                    }
                    helperText={
                      params.row.scoreErrorFiled[i] && "Cannot enter a negative number"
                    }
                    error={params.row.scoreErrorFiled[i]}
                  />
                </Box>
              ))}
            </>
          );
        } else if (params.row.type === "drop_down") {
          if (params.row.answerId.length < 6) {
            return (
              <>
                {params.row.score.map((item, i) => (
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <TextField
                      className={classes.scoreTextField}
                      name="score"
                      variant="outlined"
                      defaultValue={item}
                      type="number"
                      InputProps={{
                        inputProps: { min: 0, pattern: "[0-9]*" },
                      }}
                      onChange={e =>
                        updateScores(
                          e.target.value,
                          params.row.answerId[i],
                          params.row,
                          i
                        )
                      }
                      helperText={
                        params.row.scoreErrorFiled[i] && "Cannot enter a negative number"
                      }
                      error={params.row.scoreErrorFiled[i]}
                    />
                  </Box>
                ))}
              </>
            );
          } else {
            return (
              <TextField
                className={classes.scoreTextField}
                name="score"
                variant="outlined"
                defaultValue={params.row.score[0]}
                type="number"
                InputProps={{
                  inputProps: { min: 0, pattern: "[0-9]*" },
                }}
                onChange={e =>
                  updateScores(e.target.value, params.row.answerId[0], params.row, 0)
                }
                helperText={
                  params.row.scoreErrorFiled[0] && "Cannot enter a negative number"
                }
                error={params.row.scoreErrorFiled[0]}
              />
            );
          }
        } else if (params.row.type == "content") {
          return (
            <Typography
              variant="h3"
              style={{ fontSize: 14, paddingTop: 15, paddingRight: 120 }}
            >
              N/A
            </Typography>
          );
        }
      },
    },
  ];

  function DataGridTitle() {
    return (
      <>
        <Grid
          container
          xs={12}
          style={{
            paddingTop: 15,
            paddingBottom: 15,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Grid item xs={10} style={{ textAlign: "center" }}>
            <Typography variant="h1" style={{ fontSize: 20, paddingLeft: 100 }}>
              Score Assignment for Form: {formName}
            </Typography>
          </Grid>
        </Grid>
        <Divider />
      </>
    );
  }

  if (!loadContent && !loadData) return;
  if (assignScoresAccess)
    return (
      <div className={classes.root}>
        <Header
          breadcrumbs={[
            { label: formName, link: formLink },
            { label: "Scores", link: null },
          ]}
        />
        <div className={classes.container}>
          <DataGrid
            className={classes.dataGridStyle}
            columns={columns}
            rows={rows}
            showCellRightBorder={true}
            hideFooter={true}
            slots={{
              toolbar: DataGridTitle,
            }}
            getRowId={row => row.id}
            autoHeight={true}
            getRowHeight={() => "auto"}
            // experimentalFeatures={{ newEditingApi: true }}
          />

          {/* <div className={classes.root}>
      <Grid item style={{ textAlign: "center" }}>
        <Typography variant="h1" style={{ fontSize: 26, paddingLeft: 100 }}>
          Assign Scores to Answers in Form
        </Typography>
      </Grid>
      <Grid item style={{ textAlign: "center" }}>
        <Typography
          variant="h1"
          style={{ fontSize: 22, paddingLeft: 100, paddingTop: 20 }}
        >
          Form Name: {formName}
        </Typography>
      </Grid> */}
          {/* <div className={classes.container}>
        <DataGrid
          className={classes.dataGridStyle}
          columns={columns}
          rows={rows}
          showCellRightBorder={true}
          hideFooter={true}
          getRowId={row => row.id}
          // rowHeight={175}
          getRowHeight={() => "auto"}
        /> */}

          <Box>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 2 }}
              onClick={() => {
                saveScores();
              }}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={() => navigate(formObjPage)}
            >
              Cancel
            </Button>
          </Box>
        </div>
      </div>
    );
  else
    return (
      <div className={classes.root}>
        <div className={classes.container}>
          <AlertDialog
            title="No Permission"
            contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.'
            closeDialog={() => {
              navigate(`${project_url}/tenant/dashboard`);
            }}
          />
        </div>
      </div>
    );
}

export default ScorePage;
